import {
  getClaim,
  verifyPaymentInfo,
  verifyCompanyNameRequest,
  validateCodeRequest,
  tinAddressApiRequest,
  generateSecurityKeyRequest,
} from './requests';

export const verifyClaimSaga = async ({ action }) => {
  return getClaim(action.payload);
};

export const verifyPaymentInfoSaga = async ({ action }) => {
  return verifyPaymentInfo(action.payload);
};

export const verifyCompanyNameSaga = async ({ action }) => {
  return verifyCompanyNameRequest(action.payload);
};
export const validateCodeSaga = async ({ action }) => {
  return validateCodeRequest(action.payload);
};
export const tinAddressApiSaga = async ({ action }) => {
  return tinAddressApiRequest(action.payload);
};
export const generateSecurityKeySaga = async ({ action }) => {
  return generateSecurityKeyRequest(action.payload);
};
